import React, { useEffect } from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Checkbox from 'components/Checkbox';
import getObjectValue from 'libs/getObjectValue';
import { connect } from 'react-redux'

const style = theme => ({
	root: {
		marginBottom: theme.spacing(2),
	},
	title: {
		fontWeight: theme.typography.fontWeightBold
	},
	description: {
		marginLeft: theme.spacing(2),
		'&:not(:first-child)': {
			paddingTop: theme.spacing(1),
		}
	}
})

function Element({
	classes,
	title,
	description,
	id,
	formikProps,
	disabled,
	checked,
	espdList
}) {
	const descArr = description.split('\n')
	const editable = getObjectValue('_editable', formikProps.values, true);

	// useEffect(() => {
	// 	if (checked) formikProps.setFieldValue(id, checked)
	// 	// eslint-disable-next-line
	// }, [checked])



	useEffect(() => {
		if (espdList) {
			let newId = id.split(".")[1]
			let isChecked = getObjectValue(newId, espdList)
			if (isChecked) formikProps.setFieldValue(id, isChecked)
		}
		// eslint-disable-next-line
	}, [])


	const titleComponent = (
		<Typography variant='body1' className={classes.title}>
			{title}
		</Typography>)

	return (
		<GridBlock
			className={classes.root}
			column
		>
			<GridBlock
				wrap='nowrap'
				alignItems='center'
			>
				{Boolean(id) ?
					<Checkbox
						id={id}
						formikProps={formikProps}
						label={titleComponent}
						disabled={disabled || !editable}
					/> : titleComponent
				}
			</GridBlock>
			<>
				{descArr.map((text, i) => {
					return (
						<Typography
							key={i}
							variant='body1'
							className={classes.description}
						>
							{text}
						</Typography>
					)
				})}
			</>
		</GridBlock>
	)
}

Element.propTypes = {
	classes: PropTypes.any,
}


export default connect((state) => ({
	espdList: state.resources.espdList
}), {
	})(withStyles(style)(Element));
